import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './toast.component.scss'
})
export class ToastComponent {

  @Input() showToast: boolean | null = false;

  constructor() {
  }
 
  public close(): void { 
    this.showToast = false;
  }

}